import { IDropdownOptions, ILabelValue } from "app/containers/Features/containers/TeamSettings/container/Projects/container/CustomFields/types";

export interface ITicketTypes {
  _id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  description: string;
  icon: string;
  order?: number;
  orderLevel?: number;
  isActive: boolean;
  isArchived: boolean;
  isDefault: boolean;
  isContainerLevel: boolean;
  ticketTypeFields: TicketField[];
}
export interface IUpdateOrder {
  ticketTypeId: string;
  selectedFieldId:string;
  order: {
    before: string;
    after: string;
  };
}
export interface TicketField {
  associatedTicketTypes: string[];
  createdAt: string;
  dropDownOptions: IDropdownOptions[];
  fieldCategory: FieldCategoryTypeEnum;
  fieldName: string;
  fieldToolTip: string;
  isArchived: boolean;
  isRequired: boolean;
  isSystemField: boolean;
  isVisible: boolean;
  labels: ILabelValue[];
  order: number;
  updatedAt: string;
  _id: string;
}

export interface IUpdateWorkItems {
  id: string;
  name?: string;
  icon?: string;
  description?: string;
}
export enum FieldCategoryTypeEnum {
  HEADER_FIELDS = "Header fields",
  CONTEXT_FIELDS = "Context fields",
  ACTION_ITEMS = "Action items",
  FIGMA_ASSETS = "Figma assets",
  CUSTOM_FIELDS = "Custom fields",
}
export enum TicketTypeFieldsTooltipsEnum {
  TEAM_NAME = "Team name",
  PROJECT_NAME = "Project name",
  COMPONENT_NAME = "Component name",
  RELEASE_NAME = "Release name",
  SPRINT_NAME = "Sprint name",
  EPIC_NAME = "Epic name",
  TICKET_ID = "Ticket ID",
  TICKET_NAME = "Ticket name",
  TICKET_TYPE = "Ticket type",
  STATUS = "Status",
  ASSIGNEE = "Assignee",
  DUE_DATE = "Due date",
  PRIORITY = "Priority",
  EFFORTS_ESTIMATED = "Efforts Estimated",
  EFFORTS_ACTUAL = "Efforts Actual",
  TAGS = "Tags",
  TICKET_DESCRIPTION = "Ticket description",
  ACTION_ITEMS = "Action items",
  FIGMA_ASSETS = "Figma assets",
}
export interface WorkItemState {
  loading: boolean;
  fieldsLoading: boolean;
  buttonLoading: boolean;
  createNewLoading: boolean;
  ticketTypes: ITicketTypes[];
  selectedItem: string;
  showArchiveModal: boolean;
}
